import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import _ from 'lodash';
import { Expandable } from '@unite-us/ui';
import { isFocused, INSURANCE } from 'common/utils/isFocused';
import PaymentsInformation from 'src/components/Insurance/PaymentsInformation';
import featureFlag from 'common/utils/FeatureFlag/FeatureFlag';
import ReactFinalFormBridge from 'common/form/ReactFinalFormBridge';
import MilitaryInformation from './MilitaryInformation';

export const SupplementalInformation = ({
  contactId,
  fields,
  currentGroup,
  registerField,
  untouch,
  initialValues = {},
  onMilitaryInfoChange,
}) => {
  const showHealthInsuranceSection = isFocused(currentGroup, INSURANCE);

  // Memoize military values to avoid creating new object references on every render
  const militaryValues = useMemo(() => {
    const values = {};
    MilitaryInformation.fields.forEach((fieldName) => {
      const value = _.get(initialValues, fieldName);
      if (value !== undefined) {
        _.set(values, fieldName, value);
      }
    });
    return values;
  }, [initialValues]);

  // Stabilize callback to prevent re-creating on every render
  const handleFieldChange = useCallback((rffValues) => {
    if (onMilitaryInfoChange) {
      onMilitaryInfoChange(rffValues);
    }
    // Sync React Final Form values back to Redux Form
    MilitaryInformation.fields.forEach((fieldName) => {
      const value = _.get(rffValues, fieldName);
      if (value !== undefined) {
        const field = _.get(fields, fieldName);
        if (field && field.onChange) {
          field.onChange(value);
        }
      }
    });
  }, [onMilitaryInfoChange, fields]);

  return (
    <Expandable
      className="supplemental-information"
      header="Supplemental Information"
    >
      {
         showHealthInsuranceSection && (
         <div className="payments-insurance payments-insurance-form">
           <h3 className="payments-insurance__header mb-3">Insurance Information</h3>
           <div className="health-insurance__content">
             <PaymentsInformation
               contactId={contactId || ''}
               fields={fields}
               registerField={registerField}
               untouch={untouch}
             />
           </div>
         </div>
         )
      }
      <ReactFinalFormBridge
        initialValues={militaryValues}
        onFieldChange={handleFieldChange}
      >
        <MilitaryInformation />
      </ReactFinalFormBridge>
    </Expandable>
  );
};

SupplementalInformation.propTypes = {
  contactId: PropTypes.string,
  currentGroup: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  registerField: PropTypes.func.isRequired,
  untouch: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  onMilitaryInfoChange: PropTypes.func,
};

SupplementalInformation.defaultProps = {
  contactId: '',
  initialValues: {},
};

export default featureFlag(SupplementalInformation);
